import { Box, Button, Grid, Typography } from "@mui/material";
import PageLayout from "../../components/PageLayout";
import { setProcessing } from "../../store/ApplicationStore";
import { appRoutes } from "../../constants/ApplicationConstants";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import errorImage from '../../../src/assets/images/SomethingWentWrong.png'

 function ErrorScreen(){
    const navigate = useNavigate()
    return(
        <PageLayout header={false} footer={false}>
            <Box>
                <Grid container spacing={1} >
                    <Grid item xs={12} sx={{textAlign:'center',paddingTop:0}} >
                        <Box>
                        <img alt="explore" src={errorImage} style={{
                                        width: '30%', height: '30%'
                        }}/>
                        </Box>                                  
                    </Grid>
                    <Grid item xs={12} sx={{textAlign:'center'}}  >
                        <Typography  sx={{fontWeight:'bold',wordBreak:'break-word'}} variant="h5">
                            Something went wrong!
                         </Typography>                 
                    </Grid>
                    <Grid item xs={12} sx={{textAlign:'center'}}  >
                        <Button sx={{ textTransform: 'capitalize' }} variant='contained' color='primary' onClick={() => navigate(appRoutes.explore)}>Try again</Button>
                    </Grid>
                </Grid>
            </Box>
        </PageLayout>
    )
}

function  useHandleError() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const handleError = (err) => {
      dispatch(setProcessing(false));
      navigate(appRoutes.errorRoute);
    };
    return handleError;
  };

  export {useHandleError,ErrorScreen}